<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Peringkat Hasil Tryout</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Peringkat Hasil Tryout</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tabmateri" data-toggle="tab">Peringkat Hasil Tryout</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tabmateri" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">

													<div class="table-responsive">
                                                        <table id="tblRank" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="">Tryout</th>
                                                                    <th class="text-center">Jumlah User mengerjakan</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lstrank" :key="ref.id_to">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_to }}</td>
                                                                    <td class="text-center">{{ ref.jml_user }}</td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-warning-light" depressed small @click.prevent="hitungSkor(ref)">
                                                                           Hitung Skor
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click.prevent="getPreview(ref)">
                                                                           Lihat Skor
                                                                        </v-btn>
                                                                    </td>
                                                                  
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

       
        <div id="previewMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Detail Peringkat Tryout {{tryout.nama_to}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                       <div class="table-responsive">
                            <table id="tblHasil" class="table table-hover table-center mb-0">
                                <thead>
                                    <tr>
                                        <!-- <th class="text-center">#</th> -->
                                        <th class="text-left">Nama User</th>
                                        <th class="text-center">Rank</th>
                                        <th class="text-center">Nilai</th>
                                        <th class="text-center">Waktu</th>
                                        <th class="text-center">Tanggal</th>
                                        <!-- <th class="text-center">Action</th> -->
                                    </tr>
                                </thead>
            
                                <tbody>
                                    <tr v-for="(ref) in lsthasil" :key="ref.id_user_to">
                                        <!-- <td>{{ index + 1 }}</td> -->
                                        <td>{{ ref.namauser }}</td>
                                        <td class="text-center">{{ ref.ket }}</td>
                                        <td class="text-center">{{ ref.hasil }}</td>
                                        <td class="text-center">{{ ('0' + parseInt(parseInt(tryout.waktu) - (parseInt(ref.waktu)/60))).slice(-2) + ':' + ('0' + ((parseInt(tryout.waktu)*60)-parseInt(ref.waktu))%60).slice(-2) }}</td>
                                        <td>{{ ref.created_date }}</td>
<!--                                         
                                        <td>
                                            <v-btn class="btn btn-sm bg-success-light" depressed small @click="getDetail(ref)" data-dismiss="modal" aria-label="Close" id="hasilMdl" data-target="#hasilMdl">
                                                <i class="fas fa-eye"></i> Pembahasan
                                            </v-btn>
                                        </td> -->
                                    </tr>
                                </tbody>                                            
                            </table>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';
// import moment from "moment";

export default {
    components: {
        Sidebar
    },
	name: 'Materi',
    data() {
        return {
            lstrank:[],
            lsthasil:[],
            lsthasilsiswa:[],
            tryout: {
                id_to: '',
                nama_to: '',
                jml_user:'',
                waktu:''
            },
            siswa: {
                id_user: '',
                namauser: ''
                // jml_user:''
            },
        }
    },
    created: function () {
        // this.getAllMateri();
        this.getAll();
        // this.getAllSub();
    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },
        
        //--------------------------
        // Get Materi
        getAll: function () {
            axios.get('api/peringkatto')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblRank");
                    this.lstrank = res.data.data;
                    this.initDt("tblRank");
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        
        hitungSkor: function (ref) {
            axios.get('api/hitungSkorTo/'+ref.id_to) 
                .then(res => {

                    swal.fire("Skor  "+ref.nama_to+" selesai dihitung, silahkan lihat hasil skor :)", {
                        icon: "success",
                    });
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getPreview: function (ref) {
            this.tryout = ref;
			this.lsthasil = []; 
            this.clearTbl("tblHasil");
            axios.get('api/peringkatto/'+ref.id_to) 
                .then(res => {
                    $("#previewMdl").modal('show');
                    this.lsthasil = res.data.data;
                    this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // getPreview: function (ref) {
        //     this.siswa = ref;
		// 	this.lsthasilsiswa = []; 
        //     axios.get('api/tryoutres/'+ref.id_to+'/'+ref.id_user)
        //         .then(res => {
        //             $("#previewMdl").modal('show');

        //             this.clearTbl("tblHasilSiswa");
        //             this.lsthasilsiswa = res.data.data;
        //             this.initDt("tblHasilSiswa");
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Rank/index.vue